<i18n>
{
  "en": {
    "selectOneOrMore": "Select one or more",
    "ok": "OK"
  },
  "zh-tw": {
    "selectOneOrMore": "多選",
    "ok": "確定"
  }
}
</i18n>

<template>
  <f7-sheet style="height: 60%;">
    <f7-toolbar :color-theme="themeColor">
      <f7-link>{{ question.title }} ({{ $t(`selectOneOrMore`) }})</f7-link>
      <f7-link sheet-close>{{ $t(`ok`) }}</f7-link>
    </f7-toolbar>
    <div style="height: 100%; width: 100%; overflow: auto; padding: 10px 0px;">
      <div
        v-for="(option, index) in question.options"
        :key="`checkbox-sheet-${index}`"
        class="button"
        @click="toggleCheckbox(option)"
        style="margin: 10px 0px; text-align: left; width: 100%;">
        <span style="font-size: 16px; color: black;">
          {{ option.toString() }}
        </span>
        <span
          style="margin: 0px 12px; float: right;"
          :style="{ color: question.value.includes(option.id) ? '#4caf50' : '#DDDDDD' }">
          <font-awesome-icon icon="check" />
        </span>
      </div>
    </div>
  </f7-sheet>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'CheckboxSheetModal',
  dependencies: [
    'themeColor',
    'platformUtils',
    'CartElementBuilder'
  ],
  data () {
    return {
      itemDefinitionId: this.fullItemIdPathParam.split('.')[0],
      itemInstanceId: this.fullItemIdPathParam.split('.')[1]
    }
  },
  props: {
    itemBucketPathParam: String,
    fullItemIdPathParam: String,
    questionIdPathParam: String
  },
  computed: {
    ...mapState('itemModule', [
      'cart',
      'favorites'
    ]),
    ...mapGetters(['currentMenu']),
    itemObj () {
      return this[this.itemBucketPathParam][this.itemDefinitionId][this.itemInstanceId]
    },
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionIdPathParam, this.itemObj, this.currentMenu)
    }
  },
  methods: {
    toggleCheckbox (option) {
      this.setQuestion({
        itemBucket: this.itemBucketPathParam,
        itemId: this.itemDefinitionId,
        itemInstanceId: this.itemInstanceId,
        questionId: this.questionIdPathParam,
        value: this.question.value.some(oid => oid === option.id)
          ? this.question.value.filter(oid => oid !== option.id)
          : this.question.value.concat([option.id])
      })
    },
    ...mapActions('itemModule', [ 'setQuestion' ])
  }
}
</script>
